import { AbstractSaveableStore } from "../SaveableStore";

import Role, { RoleData } from "../../models/Role";
import API from "../../models/API";
import { StoreName } from "../../decorators/StoreNameDecorator";

@StoreName("RoleStore")
class RoleStoreClass<Number, _ extends Role> extends AbstractSaveableStore<
  Number,
  Role
> {
  storedObjectKeysEquals(a: Number, b: Number): boolean {
    return a === b;
  }

  async saveByValue(value: Role): Promise<boolean> {
    // const role: Role | undefined = this..filter(r => r.id === id)[0];
    return value.getSaveModel().save();
  }

  async lookup(roleId: Number): Promise<Role | undefined> {
    return await API.get(`/v0/role/${roleId}`)
      .then(async (value: Response) => {
        if (!value.ok) {
          return undefined;
        }
        const roleData: RoleData = (await value.json()) as RoleData;
        if (roleData) {
          return new Role(roleData);
        } else {
          return undefined;
        }
      })
      .catch(() => {
        return undefined;
      });
  }
}

const RoleStore = new RoleStoreClass();

export { RoleStore };
